import React, { useState, useEffect } from 'react'
import { PageTitle } from '../../layout/core'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'

const VideoCommentsPage = () => {
  const { videoId } = useParams()
  const [videoData, setVideoData] = useState<any>()
  const [comments, setComments] = useState([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<any>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_RESUME_PARSER_URL}/youtube-reply/get_video_comments?video_id=${videoId}`
        )
        setComments(response.data.comments)
        setVideoData(response.data)
        setLoading(false)
      } catch (err) {
        setError('Failed to fetch comments. Please try again later.')
        setLoading(false)
      }
    }

    if (videoId) {
      fetchComments()
    }
  }, [videoId])

  const handleBack = () => {
    navigate('/youtube')
  }

  if (loading)
    return (
      <div className='flex items-center justify-center h-96'>
        <div className='text-center'>
          <div className='inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500'></div>
          <p className='mt-4 text-lg font-medium text-gray-700'>Loading comments...</p>
        </div>
      </div>
    )

  if (error)
    return (
      <div className='flex justify-center items-center h-64 text-red-600 font-medium'>{error}</div>
    )

  return (
    <>
      <PageTitle breadcrumbs={[]}>Video Comments</PageTitle>

      <div className='mx-auto p-4 max-w-4xl'>
        <button
          className='btn btn-lg px-0'
          type='button'
          onClick={handleBack}
          style={{ borderRadius: '0.5rem' }}
        >
          <i className='bi bi-arrow-left fs-1'></i>
        </button>

        {/* <div className='bg-white rounded-lg shadow-md p-6 mb-6'>
          <h2 className='text-2xl font-bold mb-2'>Video Details</h2>
          <p className='mb-2'>
            <strong>Video ID:</strong> {videoId}
          </p>
          <p className='mb-4'>
            <strong>Total Comments:</strong> {videoData?.total_comments || 0}
          </p>
        </div> */}

        <div className='bg-white rounded-lg shadow-md p-6'>
          <div className='px-6 py-4 bg-gradient-to-r from-gray-50 to-blue-50 border-b border-gray-200'>
            <div className='d-flex align-items-center'>
              <div>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='text-blue-500'
                  viewBox='0 0 20 20'
                  fill='currentColor'
                  style={{ height: '3rem' }}
                >
                  <path d='M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z' />
                  <path d='M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z' />
                </svg>
              </div>
              <div className='fw-bolder fs-4'>Comments</div>
            </div>
          </div>

          {comments.length > 0 ? (
            <div className='overflow-x-auto'>
              <table className='w-full divide-y divide-gray-200'>
                <thead>
                  <tr className='bg-gray-50'>
                    <th
                      scope='col'
                      className='px-6 py-3 text-left text-xs fs-4 text-gray-500 uppercase tracking-wider w-12'
                    >
                      #
                    </th>
                    <th className='px-6 py-3 text-left text-xs fs-4 text-gray-500 uppercase tracking-wider min-w-100px'>
                      Author
                    </th>
                    <th className='px-6 py-3 text-left text-xs fs-4 text-gray-500 uppercase tracking-wider min-w-100px'>
                      Comment
                    </th>
                    <th className='px-6 py-3 text-left text-xs fs-4 text-gray-500 uppercase tracking-wider min-w-100px'>
                      Likes
                    </th>
                    <th className='px-6 py-3 text-left text-xs fs-4 text-gray-500 uppercase tracking-wider min-w-100px'>
                      Published At
                    </th>
                    <th className='px-6 py-3 text-left text-xs fs-4 text-gray-500 uppercase tracking-wider min-w-100px'>
                      Replies
                    </th>
                    <th className='px-6 py-3 text-center text-xs fs-4 text-gray-500 uppercase tracking-wider min-w-100px'>
                      Replies Likes
                    </th>
                  </tr>
                </thead>
                <tbody className='bg-white divide-y divide-gray-200'>
                  {comments.map((comment: any, index: number) => (
                    <tr
                      key={comment.comment_id}
                      className='hover:bg-gray-50 transition-colors duration-200'
                    >
                      <td className='px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500'>
                        {index + 1}.
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <div className='flex items-center'>
                          <div className='text-sm font-medium text-gray-900'>{comment.author}</div>
                        </div>
                      </td>
                      <td className='px-6 py-4'>
                        <div className='text-sm text-gray-900 max-w-md overflow-hidden text-ellipsis'>
                          {comment.text}
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <div className='d-flex align-items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            className='me-2'
                            fill='none'
                            viewBox='0 0 24 24'
                            stroke='currentColor'
                            style={{ height: '25px' }}
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth={2}
                              d='M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5'
                            />
                          </svg>
                          <span className='fw-bolder'>{comment.like_count}</span>
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-500'>
                        {new Date(comment.published_at).toLocaleString()}
                      </td>
                      <td className='px-4 py-2 whitespace-nowrap'>
                        {comment.replies && comment.replies.length > 0 ? (
                          <div className='pl-4'>
                            {comment.replies.map((reply: any) => (
                              <div key={reply.reply_id} className='text-sm my-4'>
                                {/* <strong>{reply.author}:</strong>  */}
                                <span className='badge bg-success text-white'>{reply.text}</span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <span className='badge bg-danger text-white'>No replies</span>
                        )}
                      </td>
                      <td className='px-4 py-2'>
                        {comment.replies && comment.replies.length > 0 ? (
                          <div className='pl-4'>
                            {comment.replies.map((reply: any) => (
                              // <li key={reply.reply_id} className='text-sm my-2'>
                              <div className='my-3 text-center'>
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  className='me-2'
                                  fill='none'
                                  viewBox='0 0 24 24'
                                  stroke='currentColor'
                                  style={{ height: '25px' }}
                                >
                                  <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    strokeWidth={2}
                                    d='M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5'
                                  />
                                </svg>
                                <span className='fw-bolder'>{reply.like_count}</span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='text-center mx-8 badge bg-danger text-white'>
                            No Likes
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='text-center p-4 text-gray-500'>No comments found for this video.</div>
          )}
        </div>
      </div>
    </>
  )
}

export default VideoCommentsPage
